module.exports = __webpack_public_path__ + "img/stack_0.ed48df50.png";